/**
 * Oturum jetonunun bitiş anı (ms) — imza doğrulanmaz, yalnız ``exp`` okunur.
 *
 * Kayan oturumda (AuthContext) istemci jetonu bitmeden yeniler; bitişi
 * bilmek için sunucuya sormaz. Okunamayan jeton ``0`` döner (yenileme
 * denenmez, sunucunun 401'i belirleyicidir).
 */
export function tokenExpiry(token) {
  if (typeof token !== 'string') return 0;
  const part = token.split('.')[1];
  if (!part) return 0;
  try {
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    const exp = Number(payload?.exp);
    return Number.isFinite(exp) && exp > 0 ? exp * 1000 : 0;
  } catch {
    return 0;
  }
}
